define("settings/components/meta-ad-accounts-card/assignments-modal/index", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "tracked-built-ins", "later/utils/to-array", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _tracking, _trackedBuiltIns, _toArray, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _prepopulateStaged;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"tracked-built-ins",0,"later/utils/to-array",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck }}
  <Shared::Modal @close={{@onClose}} @closeButtonQaClass="qa--mmaAssignments__dismissBtn" as |modal|>
    <modal.card @portrait={{true}} class="tAC--mmaAssignments qa--mmaAssignments">
      <modal.card-header class="tAC--mmaAssignments__header">
        <p class="o--modalHeader__title tAC--mmaAssignments__title">
          {{t "account.meta_marketing_api.assignments_modal.title"}}
        </p>
        {{#if this.metaAccountName}}
          <p class="tAC--mmaAssignments__connectedAs qa--mmaAssignments__connectedAs">
            {{t "account.meta_marketing_api.assignments_modal.subtitle_connected_as"}}
            <span class="tAC--mmaAssignments__connectedAsName">{{this.metaAccountName}}</span>
          </p>
        {{/if}}
      </modal.card-header>
      <modal.card-body>
        <p class="tAC--mmaAssignments__description qa--mmaAssignments__description">
          {{t "account.meta_marketing_api.assignments_modal.description"}}
        </p>
  
        {{#if this.showBannerError}}
          <div class="tAC--mmaAssignments__banner qa--mmaAssignments__banner">
            {{t "account.meta_marketing_api.assignments_modal.banner_error"}}
          </div>
        {{/if}}
  
        {{#if this.showBulkPill}}
          <div class="tAC--mmaAssignments__bulkPill qa--mmaAssignments__bulkPill">
            <span class="tAC--mmaAssignments__bulkCount qa--mmaAssignments__bulkCount">
              {{t "account.meta_marketing_api.assignments_modal.bulk.selected_count" count=this.multiSelectedSize}}
            </span>
            <BasicDropdown as |dd|>
              <dd.Trigger class="tAC--mmaAssignments__bulkTrigger qa--mmaAssignments__bulkAddBtn">
                {{t "account.meta_marketing_api.assignments_modal.bulk.assign_groups"}}
                {{svg-jar "caret-down" class="o--icon o--icon--xs"}}
              </dd.Trigger>
              <dd.Content class="tAC--mmaDropdown qa--mmaDropdown">
                <div class="tAC--mmaDropdown__search">
                  <input
                    aria-label={{t "account.meta_marketing_api.assignments_modal.dropdown.search_placeholder"}}
                    class="tAC--mmaDropdown__searchInput qa--mmaDropdown__bulkSearchInput"
                    placeholder={{t "account.meta_marketing_api.assignments_modal.dropdown.search_placeholder"}}
                    type="text"
                    value={{this.bulkSearchTerm}}
                    {{on "input" this.updateBulkSearch}}
                  />
                </div>
                <div class="tAC--mmaDropdown__header">
                  {{t "account.meta_marketing_api.assignments_modal.dropdown.header"}}
                </div>
                <ul class="tAC--mmaDropdown__list">
                  {{#each this.filteredGroupsForBulkWithMergeData as |entry|}}
                    <li
                      class="tAC--mmaDropdown__item qa--mmaDropdown__bulkItem
                        {{if entry.selected 'tAC--mmaDropdown__item--selected'}}
                        {{if entry.mergeTop 'tAC--mmaDropdown__item--merge-top'}}
                        {{if entry.mergeBottom 'tAC--mmaDropdown__item--merge-bottom'}}"
                      data-group-id={{entry.group.id}}
                    >
                      <label class="tAC--mmaDropdown__label">
                        <input
                          checked={{entry.selected}}
                          class="tAC--mmaDropdown__checkbox"
                          type="checkbox"
                          {{on "change" (fn this.addOrRemoveGroupBulk entry.group.id)}}
                        />
                        <span class="tAC--mmaDropdown__groupName">{{entry.group.name}}</span>
                      </label>
                    </li>
                  {{/each}}
                </ul>
              </dd.Content>
            </BasicDropdown>
          </div>
        {{/if}}
  
        <div class="tAC--mmaAssignments__selectAll">
          <input
            checked={{this.allSelected}}
            class="tAC--mmaAssignments__selectAllCheckbox qa--mmaAssignments__selectAllCheckbox"
            type="checkbox"
            {{on "change" this.toggleSelectAll}}
          />
          <span class="tAC--mmaAssignments__selectAllLabel">
            {{t "account.meta_marketing_api.assignments_modal.select_all" count=this.adAccounts.length}}
          </span>
        </div>
  
        {{#unless this.adAccounts.length}}
          <p class="tAC--mmaAssignments__emptyState qa--mmaAssignments__emptyState">
            {{t "account.meta_marketing_api.assignments_modal.no_ad_accounts"}}
          </p>
        {{/unless}}
        <ul class="tAC--mmaAssignments__list">
          {{#each this.adAccounts as |adAccount|}}
            <li
              class="tAC--mmaAssignments__row qa--mmaAssignments__row"
              data-ad-account-id={{adAccount.id}}
              data-row-state={{this.rowState adAccount.id}}
            >
              <MetaAdAccountsCard::AssignmentsModal::Row
                @adAccount={{adAccount}}
                @error={{this.errorFor adAccount.id}}
                @groups={{this.groups}}
                @groupsById={{this.groupsById}}
                @isMultiSelected={{this.isMultiSelected adAccount.id}}
                @onAddOrRemoveGroup={{fn this.addOrRemoveGroupForRow adAccount.id}}
                @onToggleMultiSelect={{fn this.toggleMultiSelect adAccount.id}}
                @rowState={{this.rowState adAccount.id}}
                @stagedGroups={{this.stagedFor adAccount.id}}
              />
            </li>
          {{/each}}
        </ul>
      </modal.card-body>
      <modal.card-footer class="tAC--mmaAssignments__footer">
        <Shared::Ui::Button
          @isDisabled={{this.cantSave}}
          @onClick={{this.save}}
          @size="small"
          @text={{t "account.meta_marketing_api.assignments_modal.save_button"}}
          @variant="primary"
          class="tAC--mmaAssignments__saveBtn qa--mmaAssignments__saveBtn"
        />
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "LT0xGORj",
    "block": "[[[8,[39,0],null,[[\"@close\",\"@closeButtonQaClass\"],[[30,1],\"qa--mmaAssignments__dismissBtn\"]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],[[24,0,\"tAC--mmaAssignments qa--mmaAssignments\"]],[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,2,[\"card-header\"]],[[24,0,\"tAC--mmaAssignments__header\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,2],[14,0,\"o--modalHeader__title tAC--mmaAssignments__title\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"account.meta_marketing_api.assignments_modal.title\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"],[41,[30,0,[\"metaAccountName\"]],[[[1,\"        \"],[10,2],[14,0,\"tAC--mmaAssignments__connectedAs qa--mmaAssignments__connectedAs\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"account.meta_marketing_api.assignments_modal.subtitle_connected_as\"],null]],[1,\"\\n          \"],[10,1],[14,0,\"tAC--mmaAssignments__connectedAsName\"],[12],[1,[30,0,[\"metaAccountName\"]]],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"]],[]]]]],[1,\"\\n    \"],[8,[30,2,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,2],[14,0,\"tAC--mmaAssignments__description qa--mmaAssignments__description\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"account.meta_marketing_api.assignments_modal.description\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"showBannerError\"]],[[[1,\"        \"],[10,0],[14,0,\"tAC--mmaAssignments__banner qa--mmaAssignments__banner\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"account.meta_marketing_api.assignments_modal.banner_error\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"showBulkPill\"]],[[[1,\"        \"],[10,0],[14,0,\"tAC--mmaAssignments__bulkPill qa--mmaAssignments__bulkPill\"],[12],[1,\"\\n          \"],[10,1],[14,0,\"tAC--mmaAssignments__bulkCount qa--mmaAssignments__bulkCount\"],[12],[1,\"\\n            \"],[1,[28,[35,1],[\"account.meta_marketing_api.assignments_modal.bulk.selected_count\"],[[\"count\"],[[30,0,[\"multiSelectedSize\"]]]]]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[8,[39,3],null,null,[[\"default\"],[[[[1,\"\\n            \"],[8,[30,3,[\"Trigger\"]],[[24,0,\"tAC--mmaAssignments__bulkTrigger qa--mmaAssignments__bulkAddBtn\"]],null,[[\"default\"],[[[[1,\"\\n              \"],[1,[28,[35,1],[\"account.meta_marketing_api.assignments_modal.bulk.assign_groups\"],null]],[1,\"\\n              \"],[1,[28,[35,4],[\"caret-down\"],[[\"class\"],[\"o--icon o--icon--xs\"]]]],[1,\"\\n            \"]],[]]]]],[1,\"\\n            \"],[8,[30,3,[\"Content\"]],[[24,0,\"tAC--mmaDropdown qa--mmaDropdown\"]],null,[[\"default\"],[[[[1,\"\\n              \"],[10,0],[14,0,\"tAC--mmaDropdown__search\"],[12],[1,\"\\n                \"],[11,\"input\"],[16,\"aria-label\",[28,[37,1],[\"account.meta_marketing_api.assignments_modal.dropdown.search_placeholder\"],null]],[24,0,\"tAC--mmaDropdown__searchInput qa--mmaDropdown__bulkSearchInput\"],[16,\"placeholder\",[28,[37,1],[\"account.meta_marketing_api.assignments_modal.dropdown.search_placeholder\"],null]],[16,2,[30,0,[\"bulkSearchTerm\"]]],[24,4,\"text\"],[4,[38,5],[\"input\",[30,0,[\"updateBulkSearch\"]]],null],[12],[13],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,0],[14,0,\"tAC--mmaDropdown__header\"],[12],[1,\"\\n                \"],[1,[28,[35,1],[\"account.meta_marketing_api.assignments_modal.dropdown.header\"],null]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,\"ul\"],[14,0,\"tAC--mmaDropdown__list\"],[12],[1,\"\\n\"],[42,[28,[37,7],[[28,[37,7],[[30,0,[\"filteredGroupsForBulkWithMergeData\"]]],null]],null],null,[[[1,\"                  \"],[10,\"li\"],[15,0,[29,[\"tAC--mmaDropdown__item qa--mmaDropdown__bulkItem\\n                      \",[52,[30,4,[\"selected\"]],\"tAC--mmaDropdown__item--selected\"],\"\\n                      \",[52,[30,4,[\"mergeTop\"]],\"tAC--mmaDropdown__item--merge-top\"],\"\\n                      \",[52,[30,4,[\"mergeBottom\"]],\"tAC--mmaDropdown__item--merge-bottom\"]]]],[15,\"data-group-id\",[30,4,[\"group\",\"id\"]]],[12],[1,\"\\n                    \"],[10,\"label\"],[14,0,\"tAC--mmaDropdown__label\"],[12],[1,\"\\n                      \"],[11,\"input\"],[16,\"checked\",[30,4,[\"selected\"]]],[24,0,\"tAC--mmaDropdown__checkbox\"],[24,4,\"checkbox\"],[4,[38,5],[\"change\",[28,[37,8],[[30,0,[\"addOrRemoveGroupBulk\"]],[30,4,[\"group\",\"id\"]]],null]],null],[12],[13],[1,\"\\n                      \"],[10,1],[14,0,\"tAC--mmaDropdown__groupName\"],[12],[1,[30,4,[\"group\",\"name\"]]],[13],[1,\"\\n                    \"],[13],[1,\"\\n                  \"],[13],[1,\"\\n\"]],[4]],null],[1,\"              \"],[13],[1,\"\\n            \"]],[]]]]],[1,\"\\n          \"]],[3]]]]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n      \"],[10,0],[14,0,\"tAC--mmaAssignments__selectAll\"],[12],[1,\"\\n        \"],[11,\"input\"],[16,\"checked\",[30,0,[\"allSelected\"]]],[24,0,\"tAC--mmaAssignments__selectAllCheckbox qa--mmaAssignments__selectAllCheckbox\"],[24,4,\"checkbox\"],[4,[38,5],[\"change\",[30,0,[\"toggleSelectAll\"]]],null],[12],[13],[1,\"\\n        \"],[10,1],[14,0,\"tAC--mmaAssignments__selectAllLabel\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"account.meta_marketing_api.assignments_modal.select_all\"],[[\"count\"],[[30,0,[\"adAccounts\",\"length\"]]]]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n\"],[41,[51,[30,0,[\"adAccounts\",\"length\"]]],[[[1,\"        \"],[10,2],[14,0,\"tAC--mmaAssignments__emptyState qa--mmaAssignments__emptyState\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"account.meta_marketing_api.assignments_modal.no_ad_accounts\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[10,\"ul\"],[14,0,\"tAC--mmaAssignments__list\"],[12],[1,\"\\n\"],[42,[28,[37,7],[[28,[37,7],[[30,0,[\"adAccounts\"]]],null]],null],null,[[[1,\"          \"],[10,\"li\"],[14,0,\"tAC--mmaAssignments__row qa--mmaAssignments__row\"],[15,\"data-ad-account-id\",[30,5,[\"id\"]]],[15,\"data-row-state\",[28,[30,0,[\"rowState\"]],[[30,5,[\"id\"]]],null]],[12],[1,\"\\n            \"],[8,[39,10],null,[[\"@adAccount\",\"@error\",\"@groups\",\"@groupsById\",\"@isMultiSelected\",\"@onAddOrRemoveGroup\",\"@onToggleMultiSelect\",\"@rowState\",\"@stagedGroups\"],[[30,5],[28,[30,0,[\"errorFor\"]],[[30,5,[\"id\"]]],null],[30,0,[\"groups\"]],[30,0,[\"groupsById\"]],[28,[30,0,[\"isMultiSelected\"]],[[30,5,[\"id\"]]],null],[28,[37,8],[[30,0,[\"addOrRemoveGroupForRow\"]],[30,5,[\"id\"]]],null],[28,[37,8],[[30,0,[\"toggleMultiSelect\"]],[30,5,[\"id\"]]],null],[28,[30,0,[\"rowState\"]],[[30,5,[\"id\"]]],null],[28,[30,0,[\"stagedFor\"]],[[30,5,[\"id\"]]],null]]],null],[1,\"\\n          \"],[13],[1,\"\\n\"]],[5]],null],[1,\"      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,2,[\"card-footer\"]],[[24,0,\"tAC--mmaAssignments__footer\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,11],[[24,0,\"tAC--mmaAssignments__saveBtn qa--mmaAssignments__saveBtn\"]],[[\"@isDisabled\",\"@onClick\",\"@size\",\"@text\",\"@variant\"],[[30,0,[\"cantSave\"]],[30,0,[\"save\"]],\"small\",[28,[37,1],[\"account.meta_marketing_api.assignments_modal.save_button\"],null],\"primary\"]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]]]],[\"@onClose\",\"modal\",\"dd\",\"entry\",\"adAccount\"],false,[\"shared/modal\",\"t\",\"if\",\"basic-dropdown\",\"svg-jar\",\"on\",\"each\",\"-track-array\",\"fn\",\"unless\",\"meta-ad-accounts-card/assignments-modal/row\",\"shared/ui/button\"]]",
    "moduleName": "settings/components/meta-ad-accounts-card/assignments-modal/index.hbs",
    "isStrictMode": false
  });
  let AssignmentsModalComponent = _exports.default = (_class = (_prepopulateStaged = /*#__PURE__*/new WeakSet(), class AssignmentsModalComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      // Pre-stage each row with its existing group assignments. Sourced directly
      // from each ad account's `groups` hasMany — backend serializes `group_ids`
      // on the MetaAdAccount payload, Ember Data parses as a hasMany ref against
      // Group records already in the store. touchedIds intentionally stays empty:
      // Save remains disabled until the user actually changes something.
      _classPrivateMethodInitSpec(this, _prepopulateStaged);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "errors", _descriptor2, this);
      _initializerDefineProperty(this, "metaMarketingApiAuth", _descriptor3, this);
      _initializerDefineProperty(this, "store", _descriptor4, this);
      _initializerDefineProperty(this, "adAccounts", _descriptor5, this);
      _initializerDefineProperty(this, "saving", _descriptor6, this);
      // Generic banner shown on a failed save. The underlying error is logged, not
      // surfaced (we don't render raw fetch messages), so this is just a flag.
      _initializerDefineProperty(this, "showBannerError", _descriptor7, this);
      _initializerDefineProperty(this, "bulkSearchTerm", _descriptor8, this);
      _defineProperty(this, "staged", new _trackedBuiltIns.TrackedMap());
      // Rows the user touched in this session (either added or removed a group).
      // Save only sends touched rows, so unchanged pre-staged rows do not generate
      // no-op writes and a row cleared back to empty still gets sent as a delete.
      _defineProperty(this, "touchedIds", new _trackedBuiltIns.TrackedSet());
      _defineProperty(this, "multiSelected", new _trackedBuiltIns.TrackedSet());
      _defineProperty(this, "savedIds", new _trackedBuiltIns.TrackedSet());
      _defineProperty(this, "failedErrors", new _trackedBuiltIns.TrackedMap());
      _defineProperty(this, "stagedFor", adAccountId => this.staged.get(adAccountId) ?? new Set());
      _defineProperty(this, "isMultiSelected", adAccountId => this.multiSelected.has(adAccountId));
      _defineProperty(this, "rowState", adAccountId => {
        if (this.savedIds.has(adAccountId)) return 'saved';
        if (this.failedErrors.has(adAccountId)) return 'error';
        return 'editable';
      });
      // eslint-disable-next-line unicorn/no-null
      _defineProperty(this, "errorFor", adAccountId => this.failedErrors.get(adAccountId)?.[0] ?? null);
      _defineProperty(this, "isBulkGroupSelected", groupId => this.bulkStagedGroups.has(groupId));
      this.loadAdAccounts();
    }
    async loadAdAccounts() {
      const records = await this.store.findAll('meta-ad-account', {
        reload: true
      });
      this.adAccounts = records.toArray().filter(r => !r.disconnectedTime);
      _classPrivateMethodGet(this, _prepopulateStaged, _prepopulateStaged2).call(this);
    }
    get groups() {
      return this.auth.currentAccount?.groups?.toArray() ?? [];
    }
    get groupsById() {
      return new Map(this.groups.map(g => [g.id, g]));
    }
    get metaAccountName() {
      return this.auth.currentUserModel?.metaAdUser?.metaAccountName;
    }
    switchMetaAccount() {
      void this.metaMarketingApiAuth.connect.perform();
    }
    get hasAnyAssignment() {
      for (const set of this.staged.values()) {
        if (set.size > 0) return true;
      }
      return false;
    }
    get canSave() {
      if (this.hasAnyAssignment) return true;
      for (const id of this.touchedIds) {
        if (!this.savedIds.has(id)) return true;
      }
      return false;
    }
    get cantSave() {
      return !this.canSave || this.saving;
    }
    get multiSelectedSize() {
      return this.multiSelected.size;
    }
    get showBulkPill() {
      return this.multiSelected.size > 0;
    }
    get allSelected() {
      return this.adAccounts.length > 0 && this.multiSelected.size === this.adAccounts.length;
    }
    // Returns the union of groups staged across all selected rows (for bulk dropdown initial state)
    get bulkStagedGroups() {
      const union = new Set();
      for (const id of this.multiSelected) {
        for (const gid of this.staged.get(id) ?? []) union.add(gid);
      }
      return union;
    }
    toggleMultiSelect(adAccountId) {
      if (this.multiSelected.has(adAccountId)) this.multiSelected.delete(adAccountId);else this.multiSelected.add(adAccountId);
    }
    toggleSelectAll() {
      if (this.allSelected) {
        this.multiSelected.clear();
      } else {
        for (const acc of this.adAccounts) {
          this.multiSelected.add(acc.id);
        }
      }
    }
    addOrRemoveGroupForRow(adAccountId, groupId, adding) {
      let set = this.staged.get(adAccountId);
      if (!set) {
        set = new _trackedBuiltIns.TrackedSet();
        this.staged.set(adAccountId, set);
      }
      if (adding) set.add(groupId);else set.delete(groupId);
      this.touchedIds.add(adAccountId);
    }
    addOrRemoveGroupBulk(groupId, event) {
      const adding = event.target.checked;
      for (const adAccountId of this.multiSelected) {
        let set = this.staged.get(adAccountId);
        if (!set) {
          set = new _trackedBuiltIns.TrackedSet();
          this.staged.set(adAccountId, set);
        }
        if (adding) set.add(groupId);else set.delete(groupId);
        this.touchedIds.add(adAccountId);
      }
    }
    get filteredGroupsForBulk() {
      const term = this.bulkSearchTerm.trim().toLowerCase();
      if (!term) return this.groups;
      return this.groups.filter(g => g.name.toLowerCase().includes(term));
    }

    // Bulk dropdown entries with adjacency metadata for the merged-selection
    // rounded shape (avoids relying on the CSS :has() selector).
    get filteredGroupsForBulkWithMergeData() {
      const list = this.filteredGroupsForBulk;
      return list.map((group, i) => {
        const selected = this.isBulkGroupSelected(group.id);
        const prevSelected = i > 0 && this.isBulkGroupSelected(list[i - 1].id);
        const nextSelected = i < list.length - 1 && this.isBulkGroupSelected(list[i + 1].id);
        return {
          group,
          selected,
          mergeTop: selected && prevSelected,
          mergeBottom: selected && nextSelected
        };
      });
    }
    updateBulkSearch(event) {
      this.bulkSearchTerm = event.target.value;
    }
    async save() {
      const assignments = [];
      // Send every touched row, including ones cleared back to empty — the
      // backend treats group_ids as the desired full set and computes diffs.
      for (const id of this.touchedIds) {
        if (this.savedIds.has(id)) continue;
        const set = this.staged.get(id) ?? new Set();
        assignments.push({
          meta_ad_account_id: id,
          group_ids: [...set]
        });
      }
      // User clicked Save while accepting the pre-staged state (Save was enabled
      // by hasAnyAssignment). Nothing to persist — just close.
      if (assignments.length === 0) {
        this.args.onClose();
        return;
      }
      this.saving = true;
      this.showBannerError = false;
      try {
        const response = await this.metaMarketingApiAuth.bulkSetGroups(assignments);
        for (const s of response.succeeded) this.savedIds.add(s.meta_ad_account_id);
        this.failedErrors.clear();
        for (const f of response.failed) this.failedErrors.set(f.meta_ad_account_id, f.errors);

        // Refresh groups so the per-group ad-account list under the modal
        // reflects the new assignments, and meta-ad-account so the account-level
        // Business Account tab table (which reads meta-ad-account via peekAll, and
        // each account's groups hasMany from the fresh group_ids) updates too.
        // Fires on any success (partial or full) since at least one group's
        // membership changed.
        if (response.succeeded.length > 0) {
          await this.store.findAll('group', {
            reload: true
          });
          await this.store.findAll('meta-ad-account', {
            reload: true
          });
        }
        if (response.failed.length === 0) this.args.onClose();
      } catch (e) {
        this.showBannerError = true;
        this.errors.log(e);
      } finally {
        this.saving = false;
      }
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "metaMarketingApiAuth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "adAccounts", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return [];
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "saving", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "showBannerError", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "bulkSearchTerm", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _applyDecoratedDescriptor(_class.prototype, "switchMetaAccount", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "switchMetaAccount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleMultiSelect", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleMultiSelect"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleSelectAll", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSelectAll"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addOrRemoveGroupForRow", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addOrRemoveGroupForRow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addOrRemoveGroupBulk", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addOrRemoveGroupBulk"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateBulkSearch", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateBulkSearch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "save", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "save"), _class.prototype)), _class);
  function _prepopulateStaged2() {
    for (const account of this.adAccounts) {
      const groups = (0, _toArray.default)(account.groups);
      if (groups.length === 0) continue;
      let set = this.staged.get(account.id);
      if (!set) {
        set = new _trackedBuiltIns.TrackedSet();
        this.staged.set(account.id, set);
      }
      for (const group of groups) set.add(group.id);
    }
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, AssignmentsModalComponent);
});